// export const title = '璞泰来行业动态管理系统';
// export const titlePrefix = '璞泰来';
// export const titleSuffix = '行业动态管理系统';
// export const type = 'ptl';

// export const title = '锦源晟电子发票管理系统';
// export const titlePrefix = '锦源晟';
// export const titleSuffix = '电子发票管理系统';
// export const type = 'jys';

export const title = '璞泰来电子发票管理系统';
export const titlePrefix = '璞泰来';
export const titleSuffix = '电子发票管理系统';
export const type = 'ptl';

export const newInterval = 30;
export const otherInterval = 90;
